import * as Sentry from '@sentry/tanstackstart-react'

export function setUser(username: string) {
  Sentry.setUser({
    username,
    id: username,
  })
}

export function clearUser() {
  Sentry.setUser(null)
}

export function trackPageView(route: string) {
  Sentry.addBreadcrumb({
    category: 'navigation',
    message: `Navigated to ${route}`,
    level: 'info',
    data: { route },
  })
  Sentry.metrics.count('page_view', 1, { attributes: { route } })
}

export function trackLogin(username: string) {
  setUser(username)
  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'User logged in',
    level: 'info',
    data: { username },
  })
  Sentry.metrics.count('user_login', 1)
}

export function trackLogout() {
  Sentry.addBreadcrumb({
    category: 'auth',
    message: 'User logged out',
    level: 'info',
  })
  Sentry.metrics.count('user_logout', 1)
  clearUser()
}

export function trackExcelDownload(artifactCount: number) {
  Sentry.addBreadcrumb({
    category: 'export',
    message: 'Excel file downloaded',
    level: 'info',
    data: { artifactCount },
  })
  Sentry.metrics.count('excel_download', 1)
  Sentry.metrics.distribution('excel_artifact_count', artifactCount)
}

export function trackFilterApplied(filterType: string, filterValue: unknown) {
  Sentry.addBreadcrumb({
    category: 'filter',
    message: `Filter applied: ${filterType}`,
    level: 'info',
    data: { filterType, filterValue },
  })
  Sentry.metrics.count('filter_applied', 1, { attributes: { filter_type: filterType } })
}

export function trackArtifactClick(artifactId: string) {
  Sentry.addBreadcrumb({
    category: 'navigation',
    message: 'Artifact clicked',
    level: 'info',
    data: { artifactId },
  })
  Sentry.metrics.count('artifact_click', 1)
}

export function trackRefresh() {
  Sentry.addBreadcrumb({
    category: 'action',
    message: 'Data refreshed',
    level: 'info',
  })
  Sentry.metrics.count('data_refresh', 1)
}

export function trackSessionStart() {
  Sentry.addBreadcrumb({
    category: 'session',
    message: 'Session started',
    level: 'info',
  })
  Sentry.metrics.count('session_start', 1)
}

export function trackSessionEnd() {
  Sentry.addBreadcrumb({
    category: 'session',
    message: 'Session ended',
    level: 'info',
  })
  Sentry.metrics.count('session_end', 1)
}
